import React, { useState, useEffect } from "react";
import {
    defineBlock,
    smartProps,
    useSmartProp,
    EditableHeading,
    EditableImg,
    useEditor,
    useInspectorControl,
} from "@smartfire/gutenberg-react";
import { PanelBody, PanelRow, TextControl } from '@wordpress/components';
import style from "./block.module.scss";
import PTCard from '../pt-card/block';
import apiFetch from '@wordpress/api-fetch';
import ArrowIcon from '@material-ui/icons/ArrowBack';

function Inspector() {
    const [url, setUrl] = useSmartProp("url")
    const [label, setLabel] = useSmartProp("label")

    return (
        <PanelBody title="Lien" initialOpen={true}>
            <PanelRow>
                <TextControl
                    label="URL page liste"
                    value={url}
                    onChange={setUrl}
                />
            </PanelRow>
            <PanelRow>
                <TextControl
                    label="Label page liste"
                    value={label}
                    onChange={setLabel}
                />
            </PanelRow>
        </PanelBody>
    )
}

const Block = ({ url, label}) => {
    const { isEditing } = useEditor();
    const [players, setPlayers] = useState([])
    useInspectorControl(Inspector)

    useEffect(() => {
        apiFetch({ path: "/wp/v2/player?_embed=1&per_page=8&orderby=menu_order" }).then(res => {
            setPlayers(res);
        })
    }, [setPlayers]);

    return ( 
        <div className={style.block}>
            <div className={style.container}>
                <div className={style.grid}>
                    <div className={style.list}>
                        <EditableHeading smartProp="title" className={style.title} />
                        <div className={style.cards}>
                            {players && players.map((team) => (
                                <PTCard
                                    url={team._embedded && team._embedded['wp:featuredmedia'] && team._embedded['wp:featuredmedia'][0] && team._embedded['wp:featuredmedia'][0].source_url}
                                    title={team.title.rendered}
                                    position={team.acf.position}
                                    from={team.acf.from}
                                    key={team.id}
                                />
                            ))}
                        </div>
                        <div className={style.wrapBtn}>
                            <a href={isEditing ? () => false : url} className={style.btn}>{label} <ArrowIcon /></a>
                        </div>
                    </div>
                    <div className={style.cover}>
                        <EditableImg smartProp="cover" />
                    </div>
                </div>
            </div>
        </div>
    );

}

export default defineBlock({
    Block,
    smartProps: {
        cover: smartProps.image,
        url: smartProps.string.withDefault('/'),
        label: smartProps.string.withDefault('Voir tous les joueurs'),
        title: smartProps.object.withDefault({
            headingLevel: 2,
            content: 'Les joueurs'
        }),
    },
    setup: {
        title: "PT Home",
    }
});
